import axios from '@_system/axios/axios.js'
export default {
	path: '/form',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	create(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/create', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	build(controll, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/build/' + window.config.app+'/'+controll, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	getRelation(controll, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getRelation/' + controll, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	saveRelation(controllName, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/saveRelation/' + controllName, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	deleteRelation(controllName, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/deleteRelation/' + controllName, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	reback(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/reback/' + id, data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	getFieldFromView(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/getFieldFromView', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/'+window.config.app+'/system.form', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
}
